import React from 'react';
import classnames from 'classnames';
import css from './checkout-block-skeleton.scss';
export const CheckoutBlockSkeleton = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(css.wrapper, className)
  }, /*#__PURE__*/React.createElement("h4", {
    className: css.title
  }, /*#__PURE__*/React.createElement("div", {
    className: css.phRow
  }, /*#__PURE__*/React.createElement("div", {
    className: css.staticCol
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: css.itemsNumber
  }, /*#__PURE__*/React.createElement("div", {
    className: css.phRow
  }, /*#__PURE__*/React.createElement("div", {
    className: css.staticCol
  }), /*#__PURE__*/React.createElement("div", {
    className: css.phCol1
  }))), /*#__PURE__*/React.createElement("div", {
    className: css.total
  }, /*#__PURE__*/React.createElement("div", {
    className: css.phRow
  }, /*#__PURE__*/React.createElement("div", {
    className: css.staticCol
  }), /*#__PURE__*/React.createElement("div", {
    className: css.phCol2
  }))), /*#__PURE__*/React.createElement("div", {
    className: css.button
  })));
};